<style>
    @import '../../custom/css/ver-cotacoes-usuarios.css';
</style>


<template>
    <div class="usuarios lista-dicas">
        <div class="row m-0" v-if="cotacoesAdministrador !== null">
            <div class="col-12">
                <table class="table">
                    <thead class="letter-orange">
                        <tr>
                            <th>E-mail, CNPJ</td>
                            <th>Data</th>
                            <th>Tipo</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="usuario in cotacoesAdministrador.lojista">
                            <td v-if="usuario.usuario !== null">{{ usuario.usuario }}</td>
                            <td v-else-if="usuario.razao_social !== null">{{ usuario.razao_social }}</td>
                            <td v-else-if="usuario.cnpj !== null">{{ usuario.cnpj }}</td>
                            <td>{{ usuario.atualizado_em }}</td>
                            <td>Lojista</td>
                            <td>
                                <div class="btn btn-relatorio text-uppercase m-0" @click="verLojista(usuario.usuario_id)">
                                    Ver relatório
                                </div>
                            </td>
                        </tr>
                        <tr v-for="usuario in cotacoesAdministrador.representante">
                            <td v-if="usuario.usuario !== null">{{ usuario.usuario }}</td>
                            <td v-else-if="usuario.razao_social !== null">{{ usuario.razao_social }}</td>
                            <td v-else-if="usuario.cnpj !== null">{{ usuario.cnpj }}</td>
                            <td>{{ usuario.atualizado_em }}</td>
                            <td>Representante</td>
                            <td>
                                <div class="btn btn-relatorio text-uppercase m-0" @click="verRepresentante(usuario.usuario_id)">
                                    Ver relatório
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row m-0" v-else>
            Sem lojistas ou representantes no sistema
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'usuarios',
        created() {
            this.$store.dispatch('showCotacoesAdministrador')
        },
        computed: {
            ...mapGetters(['getTipoNotification', 'getNotification']),
            ...mapState({
                cotacoesAdministrador: state => state.cotacoesAdministrador
            })
        },
        methods: {
            verLojista (value){
                this.$router.push({ 
                    name: 'administrador-ver-relatorio-lojista', 
                    params: { id: value }
                })
            },
            verRepresentante (value){
                this.$router.push({ 
                    name: 'administrador-ver-relatorio-representante', 
                    params: { id: value }
                })
            }
        }
    }
</script>